// import logo from "@fronterahealth/frontera-ui-components/assets/logo.svg";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";

import { Button, Headline, Paragraph } from "@fronterahealth/frontera-ui-components";

export const Login: React.FC = () => {
  const { loginWithRedirect, user, error } = useAuth0();
  if (user) return <Navigate to="/clients" />;
  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <Headline size="medium" className="mb-10 text-text-secondary">
        Frontera Portal
      </Headline>
      {error && (
        <div className="flex flex-col items-center">
          <Headline size="medium" className="text-red-500">
            Error From Auth0
          </Headline>
          <Paragraph>Something went wrong on our when we tried logging you in. Here is our error message: </Paragraph>
          <span className="my-4 text-red-700">{error.message}</span>
        </div>
      )}
      <Button
        onClick={() => {
          loginWithRedirect({
            authorizationParams: {
              audience: import.meta.env.VITE_AUTH0_AUDIENCE,
            },
          });
        }}
        appearance="primary"
        text="Sign in to Continue"
      />
    </div>
  );
};
